import React from "react";
import { Link } from "react-router-dom";

const InfrastructureEngineer = () => {
  return (
    <div className="Job-listing">
      <p>
        We’re going to make it 100x easier to build backend web services, and we
        plan to do it by automatically creating and scaling infrastructure in
        real-time as developers write code.
      </p>
      <p>
        The infrastructure piece is where you come in. Most engineering teams
        wish they had simple, scalable and reliable infrastructure. Often that
        happens too late, once a dedicated ops/infra person (or team) is hired.
        We’re building a platform so everyone will have it from the get go. We
        need you to help build it.
      </p>
      <p>You:</p>
      <ul>
        <li>
          Have built and/or scaled multiple distributed systems, helping
          companies grow 3-10x.
        </li>
        <li>
          Have a deep understanding of distributed systems, including concepts
          like Paxos, CAP and Raft.
        </li>
        <li>
          Understand the challenges of building a platform that runs other
          people’s code.
        </li>
        <li>
          Can reason about the complex tradeoffs between architectures, and have
          opinions about which ones are best for different types of problems.
        </li>
        <li>
          Are excited to share your expertise, and can be self-directed in
          figuring out things you aren’t an expert in (yet). We don’t have any
          requirements about what tech stack you’re comfortable in, because we
          think you can learn that as needed.
        </li>
        <li>Think of servers as cattle, not pets.</li>
      </ul>
      <p>
        We have a working product, and a couple companies have shipped on top of
        it. Right now we’re dogfooding our own product, and working side-by-side
        with customers to prioritize what’s next. Under the hood we’re using
        technologies like postgres, Kubernetes, and GCP.
      </p>
      <p>
        Together, we’ll come up with additional infrastructure solutions that
        we’ll need for early customers. You’ll help choose the right patterns by
        sharing the implications of early architecture choices, and the impact
        each choice would have going forward. We expect you to heavily influence
        the language and editor so they’re built with distributed systems and
        scale in mind.
      </p>
      <p>
        As our customers scale, so will we. We’ll manually figure out the right
        changes for each customer. When we’re confident in the next set of
        patterns, we’ll automate the transition. We’ll repeat that process as
        our customers grow.
      </p>
      <p>
        To apply, email{" "}
        <a href="mailto:careers@darklang.com">careers@darklang.com</a>. If you’d
        like to apply for this role, we’d love to hear what you think will be
        the most challenging piece of this, and why you’re interested in solving
        that problem. You can learn more about how we work
        <Link to="/about#values"> here</Link>.
      </p>
    </div>
  );
};

export default InfrastructureEngineer;
